<template>
  <v-dialog v-model="dialogComputed" max-width="400px" persistent>
    <v-card>
      <v-card-title class="primary white--text py-2" primary-title>
        {{ isInquiry ? $t('ELE0197') : $t('ELE0196') }}
        <v-spacer />
        <Btn icon="mdi-close" @click="close" depressed iconProp color="white" />
      </v-card-title>
      <v-container class="px-0 py-0">
        <validation-observer ref="observer" v-slot="{ invalid }">
          <v-card-text>
            <v-row>
              <v-col>
                <TextFieldRef v-if="isInquiry" :label="$t('ELE0175')" right :value="inspQty" />
                <validation-provider v-else v-slot="{ errors }" :name="$t('ELE0175')" rules="required">
                  <TextFieldInput
                    :label="$t('ELE0175')"
                    right
                    v-model="newInspQty"
                    type="number"
                    rules="inspQtyMaxValue"
                    required
                    :error-messages="errors"
                  />
                </validation-provider>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <TextFieldRef v-if="isInquiry" :label="$t('ELE0138')" :value="inspDate" />
                <TextFieldInputWithDatePicker v-else :label="$t('ELE0138')" v-model="newInspDate" required />
              </v-col>
            </v-row>
            <v-divider class="mt-8" />
            <v-card-actions>
              <v-spacer />
              <Btn v-if="isEdit" :label="$t('ELE0198')" @click="onClickRegister" :disabled="invalid" />
              <Btn v-else :label="$t('ELE0199')" @click="onClickUnregister" />
            </v-card-actions>
          </v-card-text>
        </validation-observer>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import Btn from '@/components/atoms/base/button/Btn'
import dayjs from 'dayjs'
import { ModalMode } from '@/enum'
import TextFieldInput from '@/components/atoms/base/text-field/TextFieldInput.vue'
import TextFieldInputWithDatePicker from '@/components/atoms/base/text-field/TextFieldInputWithDatePicker.vue'
import TextFieldRef from '@/components/atoms/base/text-field/TextFieldRef.vue'
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'

export default {
  name: 'RegisterInspBoxDialog',
  components: {
    Btn,
    TextFieldInput,
    TextFieldInputWithDatePicker,
    TextFieldRef,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      mode: ModalMode.EDIT,
      newInspQty: '',
      newInspDate: dayjs().format('YYYY-MM-DD'),
    }
  },
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    inspQty: {
      type: [String, Number],
      required: false,
    },
    inspDate: {
      type: String,
      required: false,
    },
    maxInspQty: {
      type: Number,
      required: true,
    },
  },

  computed: {
    dialogComputed: {
      get() {
        return this.dialog
      },
      set(value) {
        this.$emit('update:dialog', value)
      },
    },
    isInquiry: {
      get() {
        return this.mode == ModalMode.INQUIRY
      },
    },
    isEdit: {
      get() {
        return this.mode == ModalMode.EDIT
      },
    },
  },
  methods: {
    onClickRegister() {
      this.$emit('register', {
        inspQty: this.newInspQty,
        inspDate: this.newInspDate,
      })
    },
    onClickUnregister() {
      this.$emit('unregister')
    },
    close() {
      this.dialogComputed = false
    },
  },
  mounted() {
    if (this.inspQty && this.inspDate) {
      this.mode = ModalMode.INQUIRY
    } else {
      this.mode = ModalMode.EDIT
    }
    extend('inspQtyMaxValue', {
      validate: (value) => {
        if (value >= 0 && value <= this.maxInspQty) return true
        else return this.$t('MSG0026', { p0: this.$t('ELE0175'), p1: '0', p2: this.maxInspQty })
      },
    })
  },
}
</script>
